export const readyTopicNameBuilder = elementName => `customElementReady:${elementName}`;
export { registerConfiguration } from "./registerConfiguration";
export { configurationBuilder } from "./configurationBuilder";
export { setWebpackPublicPath } from "./setWebpackPublicPath";
export { registerApplicationElement, notifyNewToken, watchForNewToken } from "./application";